export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS'



// WEBPACK FOOTER //
// ./src/Reducers/Filter/const.js